export class Cloud {
  constructor(difference) {
    this.styleId = 1
    this.width = 300
    this.height = 300
    this.top = 10
    this.left = 10
    this.innerElement = "cxCloud"
    this.openBlankPage = true
    this.linkUrl = ""
    this.restDataUrl = "" // 外接数据源地址
    this.fontFamily = "sans-serif"
    this.lineHeight = 34
    this.fontSize = 24
    this.fontWeight = "normal"
    this.bgColor = "rgba(255,255,255,0)"
    this.color = "rgba(0, 0, 0, 0.8)"
    this.colorType = "纯色"
    this.startColor = "rgba(0, 0, 0, 0.8)"
    this.endColor = "rgba(0, 0, 0, 0.8)"
    this.colorlinearGradientAngle = 90
    this.bgType = "自定义"
    this.letterSpacing = 0
    this.fontStyle = "normal"
    this.minFontSize = 12
    this.maxFontSize = 20
    this.rotate = 0
    this.animateRotate = 0
    this.animateSpeed = 600
    this.isAnimate = true
    this.colorList = [
      "#0047FF",
      "#00E4E4",
      "#FFA63F",
      "#D627B0",
      "#C035E3",
      "#802CF5",
      "#8BFF4A",
      "#FFA429",
      "#FF5C5A",
      "#FF58C7",
      "#53FFAC",
      "#FFF91F",
      "#41FFD1",
      "#6D5CFF",
      "#0089FF",
      "#FF6969",
      "#83FF7D",
      "#4EDBFF",
      "#E3FF59",
      "#B700FF"
    ]
    this.textIndent = 0
    this.textDirection = "horizontal" //horizontal vertical
    this.cloudDatas = [
      { link: "05023f8da31c4b4187cc6899e2a3aec2", name: "镇远县" },
      { link: "0ef028e5278f4f5ca31f99f1bd22b1cc", name: "剑河县" },
      { link: "1a32ef04d3c548eaa6777abb46da32f2", name: "台江县" },
      { link: "2c26488325bd493687d16315fe0e5fdd", name: "岑巩县" },
      { link: "3a786111828a4b9f89ae9da25753eedd", name: "黎平" },
      { link: "4ed593eed91b4244969995237f5c96c5", name: "丹寨县" },
      { link: "615d2c178f1a47cb8d473823e74f5386", name: "凯里市" },
      { link: "76f652df03db43349272a9aff492b065", name: "榕江县" },
      { link: "8ff29d0d35e548feb945063b34ed9c9b", name: "黄平县" },
      { link: "a8ac2170008746fdadc05ea461bc5e37", name: "雷山县" }
    ]
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
